const itCH= {
    login: {
      title: 'Accesso',
      sign_in_btn: 'Accesso'
    },
    bar: {
        logout: 'Disconnessione',
        languages: 'Lingue',
        settings: 'Apra le impostazioni'
    },
    language: {
      name: 'Italiano (Svizzera)',
    },
    attributePage: {
        title: 'Modifiche degli attributi',
        viewChanges: 'Vedi modifiche',
        dateTime: 'Data',
        notificationType: 'Tipo di notifica',
        notificationValue: 'Valore di notifica',
        oldValue: 'Vecchio valore',
        newValue: 'Nuovo valore',
        accept: 'Accettare',
        reject: 'Rifiutare',
    },
    Home: 'Home',
    load: 'Caricamento iniziale in corso...',
    Requested: "Richiesta",
    Viewed: "Visualizzata",
    Executing: "In esecuzione",
    Completed: "Completata",
    Expired: "Scaduta",
    Cancelled: "Annullata",
    Error: "Errore",
    Rejected: "Rifiutata",
    error: 'Qualcosa è andato storto; riprovi più tardi.',
    displayname: 'Nome visualizzato',
    givenname: 'Nome',
    surname: 'Cognome',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Nome',
    firstname: 'Nome',
    lastname: 'Cognome',
    footer_copyright: 'Tutti i diritti sono riservati.'
  };
  
  export default itCH;
  